<template>
    <main-content with_go_back_bar>
        <component :is="selectedComponent"></component>
    </main-content>
</template>

<script>

import coreTransactionRouting from './components/core-transaction-routing.vue';
import starshopTransactionRouting from './components/starshop-transaction-routing.vue';
import mainContent from '@/components/main-content'

export default {
    components: {
        coreTransactionRouting,
        starshopTransactionRouting,
        'main-content': mainContent,
    },  
    computed: {
        selectedComponent() {
            return this.$route.path.includes('starshop') ? 'starshop-transaction-routing' : 'core-transaction-routing'
        }
    }
}
</script>

<style scoped></style>